var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

const getProductInfoFromSWData = function(spin) {
  const products = window.sw.data.tracking.products;
  return products[spin];
};

const getEventAddToCartData = function(eventData, product){
  const location = eventData.location;
  if (!eventData.spin) {
    return;
  }

  // data format comes from GTM https://developers.google.com/tag-manager/enhanced-ecommerce#cart
  const ecommerce_data = {
    currencyCode: 'USD',
    add: {
      actionField: {
      },
      products: []
    }
  };


  if (location === 'ItemPurchaseForm') {
    // only ItemPurchaseForm uses product model
    if (!product) {
      return;
    }
    var selectedMaterialOption = $('[data-sw-material-selector-dropdown]').find(':selected');
    var isOwner = sw.data.userId === product.get('ownerId');
    ecommerce_data.add.products.push({
      id: product.get('spin') + '-' + product.get('currentConfigurationId'),
      name: product.get('productTitle'),
      category: product.get('categories')[0],
      variant: product.get('shopperTitle') || eventData.material,
      price: product.get('shopperPrice') || eventData.price,
      quantity: eventData.quantity,
      dimension1: product.get('ownerName'),
      dimension2: product.get('shopperTitle') || eventData.material,
      dimension3: selectedMaterialOption.data('swMaterialColor') || '',
      dimension4: selectedMaterialOption.data('swMaterialFinish') || '',
      metric1: product.get('shopperPrice') || eventData.price,
      dimension8: isOwner ? 'yes' : 'no'
    });
  } else if (location === 'GiftCardPage') {
    ecommerce_data.add.products.push({
      id: eventData.itemId + '-' + eventData.productConfigurationId,
      name: `$${eventData.price} Digital Gift Card`,
      category: '/gifts/cards',
      variant: `$${eventData.price}`,
      price: eventData.price,
      dimension1: 'Shapeways',
      dimension2: '',
      dimension3: '',
      dimension4: '',
      metric1: eventData.price,
      quantity: 1, // can only add gift cards to cart once at a time
      dimension8: 'no'
    });
  } else if (location === 'ModelUpload') {
      ecommerce_data.add.products.push({
          id: eventData.id,
          name: eventData.name,
          category: eventData.category,
          variant: eventData.variant,
          price: eventData.price,
          quantity: eventData.quantity,
          dimension1: eventData.dimension1,
          dimension2: eventData.dimension2,
          dimension3: eventData.dimension3,
          dimension4: eventData.dimension4,
          metric1: eventData.metric1,
          dimension8: 'yes'
      });
  } else {
    return;
  }
  return ecommerce_data;
};

const getEventRemoveFromCartData = function(eventData){
  let productId = eventData.spin + '-' + eventData.pconfId;
  let product = window.sw.data.tracking.products.filter((product) => product.id === productId);
  // data format comes from GTM https://developers.google.com/tag-manager/enhanced-ecommerce#cart
  const ecommerce_data = {
    currencyCode: 'USD',
    remove: {
      actionField: {
      },
      products: product
    },
  };

  return ecommerce_data;
};

const getEventProductDetailData = function(spin){
  const productInfo = getProductInfoFromSWData(spin);

  if (!productInfo) {
    return;
  } else {
    productInfo.quantity = 1;
    return {
      currencyCode: 'USD', //this is the user selected value; defaults to USD
      detail: {
        products: [productInfo],
      },
    };  
  }
};

const getEventProductClickData = function(eventData) {
  const productInfo = getProductInfoFromSWData(eventData.spin);
  const location = eventData.location;
  let listVal = 'Search Result';
  if(location === 'shops-profile'){
      listVal = 'Shop';
  }
  else if (location === 'product-view'){
      listVal = 'Product Detail';
  }

  if (!productInfo) {
    return;
  } else {
      productInfo.position = eventData.position;
    return {
      currencyCode: 'USD', //this is the user selected value; defaults to USD
      click: {
        actionField: {list: listVal},
        products: [productInfo],
      },
    };
  }
};

const getEventPromoClickData = function(eventData){
  // data format comes from GTM enhanced ecommerce https://developers.google.com/tag-manager/enhanced-ecommerce#promotion-data
  const ecommerce_data = {
    promoClick: {
      promotions: [{
        id: 'website-top-banner',
        name: eventData.name,
        creative: 'banner1',
        position: 'slot1',
      }],
    },
  };

  return ecommerce_data;
};

const getEventPromoViewData = function(eventData){
  // data format comes from GTM enhanced ecommerce https://developers.google.com/tag-manager/enhanced-ecommerce#promotion-data
  const ecommerce_data = {
    promoView: {
      promotions: [{
        id: 'website-top-banner',
        name: eventData.name,
        creative: 'banner1',
        position: 'slot1',
      }],
    },
  };

  return ecommerce_data;
};

const getCheckoutStepData = function(products, stepNumber, isCurrentStep){
  const ecommerce_data = {
    'checkout': {
      'actionField': {'step': stepNumber}
    }
  };
  if(isCurrentStep){
    ecommerce_data.checkout.products = products;
  }
  return ecommerce_data;
};

const getCheckoutOptionData = function(stepNumber, checkoutOption){
  const ecommerce_data = {
    'checkout_option': {
      'actionField': {'step': stepNumber, 'option': checkoutOption}
    }
  };
  return ecommerce_data;
};

module.exports = {
  getEventAddToCartData,
  getEventRemoveFromCartData,
  getEventPromoClickData,
  getEventPromoViewData,
  getEventProductDetailData,
  getEventProductClickData,
  getCheckoutStepData,
  getCheckoutOptionData
};
